<script lang="ts">
  import { cn } from '@/lib/utils/cn'

  export let className: string = ''
</script>

<svg
  class={cn('animate-spinner-rotate size-10', className)}
  viewBox="0 0 50 50"
>
  <circle
    class="animate-spinner-dash"
    cx="25"
    cy="25"
    r="20"
    fill="none"
    stroke="#5DCAA5"
    stroke-width="4"
    stroke-linecap="round"
    stroke-dasharray="1,150"
    stroke-dashoffset="0"
  />
</svg>
